import GetAlertMessage from './ServiceAlert/GetAlertMessage';
import ConfirmServiceAlert from './ServiceAlert/ConfirmServiceAlert';
import IdleTimeout from './ServiceAlert/IdleTimeout';
import ServiceAlertLoginCheck from './ServiceAlert/ServiceAlertLoginCheck';
import LoginCheck from './LoginCheck';
import Logout from './Logout';

import LoginViewData from './1_LoginPage/LoginViewData';
import LoginPostBack from './1_LoginPage/LoginPostBack';
import CheckBid from './1_LoginPage/CheckBid';
import LoginQueryMobile from './1_LoginPage/LoginQueryMobile';
import SendSmsOtp from './1_LoginPage/SendSmsOtp';
import VerifyMobile from './1_LoginPage/VerifyMobile';

import BusinessSelectionViewData from './BusinessSelection/BusinessSelectionViewData';
import BusinessSelectionPostBack from './BusinessSelection/BusinessSelectionPostBack';
import FileUploadViewData from './FileUpload/FileUploadViewData';
import GenerateToken from './Token/GenerateToken';
import ClientUploadSingleFile from './FileUpload/UploadSingleFile';
import ClientUploadIdFrontFile from './FileUpload/UploadIdFrontFile';
import DeleteUploadedFile from './FileUpload/DeleteUploadedFile';
import CompleteDocumentCase from './DocumentCase/CompleteDocumentCase';
import CancelUploading from './DocumentCase/CancelUploading';
import GetTdccTXID from './Tdcc/GetTdccTXID';
import RemoveTxID from './Tdcc/RemoveTxID';

export default {
    GetAlertMessage,
    ConfirmServiceAlert,
    ServiceAlertLoginCheck,
    IdleTimeout,

    LoginCheck,
    Logout,

    LoginViewData,
    LoginPostBack,
    CheckBid,
    LoginQueryMobile,
    SendSmsOtp,
    VerifyMobile,

    BusinessSelectionViewData,
    BusinessSelectionPostBack,
    FileUploadViewData,
    GenerateToken,
    ClientUploadSingleFile,
    ClientUploadIdFrontFile,
    DeleteUploadedFile,
    CompleteDocumentCase,
    CancelUploading,
    GetTdccTXID,
    RemoveTxID
};
